import { Module } from "@nestjs/common";
import { NeedleModelEntity } from "./entity/needle-model-entity";
import { NeedleModelRepository } from "./repository/needle-model-repository";
import { NeedleModelController } from "./needle-model-controller";
import { NeedleModelService } from "./needle-model-service";
import { TypeOrmModule } from "@nestjs/typeorm";

@Module({
    imports: [TypeOrmModule.forFeature([NeedleModelEntity])],
    controllers: [NeedleModelController],
    providers: [NeedleModelService,NeedleModelRepository],
    exports: [NeedleModelService]
})
export class NeedleModelModule { }